<!-- Based on https://github.com/fpapado/blurhash-img -->

<template>
  <div
    class="relative w-full aspect-[4/3] object-cover rounded-md "
  >
    <img
      v-if="placeholderSrc"
      :src="placeholderSrc"
      class="absolute inset-0 w-full h-full rounded-md"
    >
  </div>
</template>

<script setup>
import { useProp } from '@/composables/useProp.js'
import { decode } from 'blurhash'
import { computed } from 'vue'

const props = defineProps({
  blurhash: useProp(String)
})

function getDataUrlFromArr (arr, w, h) {
  if (typeof w === 'undefined' || typeof h === 'undefined') { w = h = Math.sqrt(arr.length / 4) }

  const canvas = document.createElement('canvas')

  const ctx = canvas.getContext('2d')

  canvas.width = w
  canvas.height = h

  const imgData = ctx.createImageData(w, h)
  imgData.data.set(arr)
  ctx.putImageData(imgData, 0, 0)

  return canvas.toDataURL()
}

const placeholderSrc = computed(() => {
  if (!props.blurhash || props.blurhash.length < 6) { return '' }
  const pixels = decode(props.blurhash, 32, 32)
  return getDataUrlFromArr(pixels, 32, 32)
})

</script>
